<style lang="less">
.product-upload-view {
  div {
    display: flex;
  }
}
</style>
<template>

  <el-card>
    <div slot="header">
      <h1 class="has-operation">
        <span>“{{activity.activityName}}”商品清单</span>
      </h1>
      <div class="header-index-content">
        <p>请下载商品导入模板，按照表格模板完善本次内购活动商品后导入</p>
        <p class="content-link">
          <a href="javascript:;" @click="downloadTemplate">
            <icon name="arrow_downward" />下载导入模板
          </a>
          <uploader
            classString="product-upload-view"
            target="activity-products-import"
            :params="{activityId: activity.id}"
            @success="handleImportSuccess"
            @error="handleImportError"
            accept=".xlsx,.xls,.csv"
          >
            <a href="javascript:;">
              <icon name="arrow_upward" />导入
            </a>
          </uploader>
          <a href="javascript:;" @click="showDeleteModal">
            <icon name="delete" />批量删除
          </a>
          <a href="javascript:;" @click="deleteAllGoods">
            <icon name="delete" />全部删除
          </a>
        </p>
      </div>
    </div>
    <el-form inline :model="specQuery" class="filter-form">
      <!-- <el-form-item label="商品名称/商品编码">
        <SpecPicker
          v-model="specQuery.sku"
          v-bind:action="specPickerOptions.action"
          v-bind:labelField="specPickerOptions.labelField"
          v-bind:valueField="specPickerOptions.valueField"
          v-bind:keywordField="specPickerOptions.keywordField"
          v-bind:_placeholder="specPickerOptions._placeholder">
        </SpecPicker>
      </el-form-item> -->
      <el-form-item label="商品名称">
        <el-input v-model="query.productName" placeholder="请输入商品名称" clearable @change='queryCollection'></el-input>
      </el-form-item>

      <el-form-item label="商品编码">
        <el-input v-model="specQuery.sku" placeholder="请输入商品编码" clearable @change='queryCollection'></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="queryCollection">查询</el-button>
      </el-form-item>
    </el-form>

    <el-table class="table block" v-loading="loading" :data="collection">
      <el-table-column prop="product.productName" label="商品名称" />
      <el-table-column prop="productSpec.sku" label="商品编码" />
      <el-table-column prop="price" label="内购价格" />
      <el-table-column prop="stock" label="可售数" />
      <el-table-column prop="mark" label="标记" :formatter="$tableHelper.fmts.enums.productMark" />
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="removeProduct(scope.row)">移除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination :total="total" :pagination="pagination" :changed="queryCollection" />
    <el-dialog title="批量删除" :visible="deleteModal"  @close="deleteModal = false" top="calc(50vh - 159px)">
      <el-input type="textarea" :rows="6" placeholder="请输入SKU,以英文字符,隔开" v-model="deleteValue"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteModal = false">取 消</el-button>
        <el-button type="danger" @click="batchDelete">删 除</el-button>
      </span>
    </el-dialog>
    <el-dialog title="导入结果" :visible="successModal" @close="successModal = false" width="500px">
      <div style="display:flex;flex-direction:row;align-items:center">
        <i class="el-icon-success" style="color:green"></i>
      <div style="color:green;margin-left:5px;">成功导入了{{exportData.count}}条数据,以下数据未导入成功</div>
      </div>
      <el-table class="table block" :data="exportData.errors" height="400px">
        <el-table-column prop="sku" label="商品SKU" />
        <el-table-column prop="remark" label="错误原因" />
    </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="successModal = false">确 定</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  const { mapGetters } = createNamespacedHelpers('activityProducts')

  import SpecPicker from "@/components/SpecPicker";

  export default {
    components: {
      SpecPicker
    },
    data() {
      return {
        exportData: {},
        successModal: false,
        isBatchDelete: false,
        deleteModal: false,
        deleteValue: '',
        loading: false,
        activityId: 0,
        activity: {},
        query: {
        },
        specPickerOptions : {
          action : 'product-specs',
          labelField : '',
          valueField : '',
          keywordField : 'name',
          defaultValue : '',
          _placeholder : '商品名称/商品编码',
        },
        specQuery: {
          sku: ''
        }
      }
    },
    computed: {
      ...mapGetters(['collection', 'total', 'pagination']), // 映射必要数据
    },
    methods: {
      async batchDelete() {
        if (this.isBatchDelete) {
          return
        }
        if (!this.deleteValue) {
          this.$message.warning('请输入SKU')
          return
        }
        this.isBatchDelete = true
        try {
          await this.$store.dispatch('activityProducts/checkBatchProductDelete', {
            activityId: this.activityId,
            skus: this.deleteValue
          })
        } catch(error) {
          this.isBatchDelete = false
          return
        }

        await this.$confirm('确认删除当前SKU?')
        try {
          await this.$store.dispatch('activityProducts/batchProductDelete', {
            activityId: this.activityId,
            skus: this.deleteValue
          })
          this.deleteModal = false
          this.queryCollection()
        } finally {
          this.isBatchDelete = false
        }
        
      },
      async deleteAllGoods() {
        await this.$confirm('确认删除全部SKU?')
        await this.$store.dispatch('activityProducts/batchProductDelete', {
          activityId: this.activityId,
        })
        this.$message.success('商品删除操作完成')
        this.queryCollection()
      },
      showDeleteModal() {
        this.deleteValue = ''
        this.deleteModal = true
      },
      async queryCollection({pagination = {}} = {}) {
        let query = {
          activityId: this.activityId,
          ...this.query,
        }

        const specQuery = {
          ...this.specQuery,
          sku: this.specQuery.sku ? (this.specQuery.sku).replace(/^\s*|\s*$/g,"") : undefined
        }

        const productQuery = {
          productName: this.query.productName ? `%${(this.query.productName).replace(/^\s*|\s*$/g,"")}%` : undefined // 设为模糊搜索
        }
        try {
          this.loading = true
          await this.$store.dispatch('activityProducts/collection', {
            query,
            relsQuery: {productSpec: specQuery, product: productQuery},
            pagination
          })
        } finally {
          this.loading = false
        }
      },
      async removeProduct(product) {
        await this.$confirm(`是否确定将【${product.product.productName}（${product.productSpec.specName}）】从清单中移除？`)
        await this.$store.dispatch('activityProducts/remove', product)
        await this.queryCollection()
        this.$message.success('商品删除操作完成')
      },
      async downloadTemplate() {
        this.$linkHelper.redirect('activity-products-template')
      },
      handleImportSuccess(res) {
        this.exportData = res
        if(res.errors.length>0){
          this.successModal = true
        }else{
           this.$message.success(`成功导入了${res.count}条数据`)
        }
        this.queryCollection()
      },
      handleImportError(error) {
        this.$message.error('导入失败了：' + error.message)
      }
    },
    async mounted() {

      const {id} = this.$route.params
      this.activityId = id

      this.queryCollection()

      const { document } = await this.$store.dispatch('activities/document', id)
      this.activity = document

    }
  }
</script>
